<template>
    <div>
        <div class="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div class="container">
                <div class="row g-5">
                    <div class="col-12 text-center">
                        <nav aria-label="breadcrumb" class="float-right">
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:void(0)" @click="$router.push({ path: '/'})">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Power Chat</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <!-- About Start -->
        <div class="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div class="container">
                <div class="row g-5">
                    <div class="col-lg-12">
                        <div class="section-title position-relative pb-3 mb-3">
                            <h1>About Power Chat</h1>
                        </div>
                        <p>Power chat is a chat messenger with complete privacy and security. Users can only communicate within a private user list that has been created by the Power chat user who has purchased the licenses.</p>
                        <p>Cloud portal is available for user and license management.</p>
                        <h4><b>Key features:</b></h4>
                        <div class="row g-0 mb-3">
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Privacy:</b>Contacts cannot communicate with outside groups even if the other party users Powerchat. No need for mobile number or email address. User ID can be anonymous</h6>
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Encryption:</b>Whole communication is encrypted to provide the ultimate level of security from threat actors.</h6>
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Media Vault:</b>All user media files ( Audio, video, pictures, documents) can be safely stored in the users app vault. Android file system and other apps cannot access the media file.  A separate password is needed to access media files.</h6>
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Security:</b>Application PIN is enabled based on time and when app goes to background. This ensured that there is no unauthorized access.</h6>
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Cloud controls:</b>Complete user and license management.  Users can be added and deleted. All users create by the Power chat license purchaser will belong to a single virtual organization.</h6>
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Login using QRCODE:</b>User can login using QRCODES and can also add other contacts using QRCODE.</h6>
                            <h6 class="mb-3"><i class="fa fa-check text-primary me-3"></i><b>Message Burn:</b>Chat messages can be configured to disappear on receipt or time. No trace of the message is available on the device or any servers.</h6>
                        </div>
                        <h4><b>Cloud usage guide</b></h4>
                        <ol>
                            <li>Purchase or try the Power chat from package disabler website. Then login to the cloud portal (<a href="https://app.packagedisabler.com">https://app.packagedisabler.com</a>) with your credentials to manage users.</li>
                            <li>
                                Please select the Power chat menu on the left side panel and press the  CREATE USER BUTTON.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="aboutPChatImage" alt="About Power Chat">
                                </div>
                            </li>
                            <li>
                                Provide the user an identifiable name, an ID and a password. Name is a display name for your reference. ID and password is needed for application login.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="createPChatUser" alt="Create Power Chat User">
                                </div>
                            </li>
                            <li>
                                Once the user is created, you can this user in a list with its creation date and ability to obtain the login QRCODE and to delete the user.
                                <b>Please scan the QRCODE from the power chat app to login.</b>
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="listPChatUser" alt="List Power Chat Users">
                                </div>
                            </li>
                        </ol>
                        <h4><b>Application Guide</b></h4>
                        <ol>
                            <li>Download Power chat from the purchase email or from the cloud portal and install it.</li>
                            <li>
                                Launch the Power chat app and press the scan icon to scan the QRCODE or enter the user id and password to login.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appLogin" alt="Power Chat Login">
                                </div>
                            </li>
                            <li>
                                <b>MAIN screen: </b> Upon login, three menus will be displayed, chats, contacts and vault. 
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appMainScreen" alt="Power Chat Home Page">
                                </div>
                            </li>
                            <li>
                                <b>CONTACT screen: </b> Contacts need to be added from the contact menu by search and add or by scanning QRCODE. The QRCODE to share with your contact can be obtained from the profile page that can be accessed by clicking the man icon on the top of the chat app.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appAddContactScreen" alt="Add Contact">&nbsp;
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appListContactScreen" alt="List Contact">
                                </div>
                                <p>The user request is sent when the user is added. You can delete a contact from this page. When a contact request is received it has to be approved to start conversation with the contact.</p>
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appAcceptContactScreen" alt="Invitation List Page">
                                </div>
                            </li>
                            <li>
                                <b>CHAT screen: </b> To start a conversation, please click on the contact to open a conversation screen. Media files can be sent from the camera ,gallery, document, video and vault.Click on the mic icon to send audio recordings. Clicking on the mask icon enables disappearing messages that the deleted once the contact views the message. 
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appChatScreen" alt="Chat Screen">&nbsp;
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appChatMediaOptionScreen" alt="Chat Media">
                                </div>
                                <p>More chat options are available by clicking the settings icon on the top right. Each message can be selected and upon selection the options to forward, copy are delete can be made available.</p>
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appChatMoreOptionScreen" alt="Chat More Options">
                                </div>
                            </li>
                            <li>
                                <b>Vault screen: </b> All media files are stored in a password protected safe storage. 
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appVaultScreen" alt="Vault">&nbsp;
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appVaultListScreen" alt="Application Vault">
                                </div>
                            </li>
                            <li>
                                <b>Profile Settings screen: </b> This can be accessed by clicking the main icon from the main screen.Application password, PIN for app timeout, sound modulation and logout option are listed. The QRCODE to share with other contact is also shown on this page.
                                <div class="position-relative h-100">
                                    <img class="img-fluid" data-wow-delay="0.9s" :src="appProfileScreen" alt="Profile Page">
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <!-- About End -->
    </div>
</template>
<script>
export default {
    props: {
        aboutPChatImage: {
            type: String,
            default: "./img/powerchat/powerchatinfo.png",
        },
        createPChatUser: {
            type: String,
            default: "./img/powerchat/CreatePchatUser.png",
        },
        listPChatUser: {
            type: String,
            default: "./img/powerchat/PchatListUsers.png",
        },
        appLogin: {
            type: String,
            default: "./img/powerchat/AppLogin.png",
        },
        appMainScreen: {
            type: String,
            default: "./img/powerchat/AppMainScreen.png",
        },
        appAddContactScreen: {
            type: String,
            default: "./img/powerchat/AppAddContact.png",
        },
        appListContactScreen: {
            type: String,
            default: "./img/powerchat/AppContactList.png",
        },
        appAcceptContactScreen: {
            type: String,
            default: "./img/powerchat/AppAcceptRequest.png",
        },
        appChatScreen: {
            type: String,
            default: "./img/powerchat/AppChatScreen.png",
        },
        appChatMediaOptionScreen: {
            type: String,
            default: "./img/powerchat/AppChatMediaOption.png",
        },
        appChatMoreOptionScreen: {
            type: String,
            default: "./img/powerchat/AppChatMoreOptions.png",
        },
        appVaultScreen: {
            type: String,
            default: "./img/powerchat/AppVaultPassword.png",
        },
        appVaultListScreen: {
            type: String,
            default: "./img/powerchat/AppVaultList.png",
        },
        appProfileScreen: {
            type: String,
            default: "./img/powerchat/AppProfile.png",
        }
    },
    created () {
        let currentUrl = window.location.href;
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical !== null) {
            canonical.href = currentUrl;
        }
    },    
}
</script>